import httpClient from '@utils/httpClient.js';

export function updateSpacerApiCall({ id, isActive, value }) {
  return httpClient.put(`api/spacer-blocks/${blockId}`, {
    id,
    isSpacer: isActive,
    spacerValue: value,
  });
}
